'use client';

import useSWR from 'swr';
import type { ModalPanelProps } from '@/ui/Modal';

export type OptimisticModalState = {
  variant?: ModalPanelProps['variant'];
  appear?: boolean;
  withoutBackdrop?: boolean;
  className?: string;
  closed?: boolean;
} | null;

export type OptimisticModalResponse = [
  OptimisticModalState,
  (action: OptimisticModalState) => void,
];

const useOptimisticModal = (): OptimisticModalResponse => {
  const optimisticModal = useSWR<OptimisticModalState>(
    'optimistic-modal',
    () => null,
    {
      fallbackData: null,
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateIfStale: false,
    },
  );

  return [
    optimisticModal?.data ?? null,
    (state) =>
      optimisticModal.mutate(state, {
        revalidate: false,
        optimisticData: state,
      }),
  ];
};

export default useOptimisticModal;
